<template>
  <div class="project-view" :class="view_position" v-if="project">
    <div class="project">
      <div class="project-name" @click="backToClients()">
        <div class="mr-4">
          <i class="fas fa-chevron-left"></i>
        </div>
        <div class="name subheading">{{ project ? project.name : null }}</div>
        <div @click.stop="edit()">
          <i class="fas fa-edit"></i>
        </div>
      </div>
      <div class="pr-16 pl-16 progress-bar-holder flex">
        <div class="mr-2">Project progress</div>
        <progress-bar :fill="project.completion_percentage"></progress-bar>
      </div>
      <div class="pr-16 pl-16 mt-8 flex">
        <div>Project deadline</div>
        <div class="flex-grow-1 text-right">{{ _project_deadline }}</div>
      </div>
      <div class="pl-16 pr-16 mt-8 w-100">
        <div class="btn btn-secondary w-100" @click="showProject()">Open project details</div>
      </div>
      <div class="divider mt-16 mb-16"></div>
    </div>
    <div class="flex pr-16 pl-16">
      <div class="subheading color-jet flex-grow-1">
        Tasks
      </div>
      <div>
        <div class="btn btn-secondary" @click="createTask()">
          <i class="fas fa-plus"></i>
        </div>
      </div>
    </div>
    <div v-if="!tasks || tasks.length == 0" class="mt-5 subheading color-gray-500 text-center w-100 flex align-items-center justify-content-center">This project does not have any tasks.</div>
    <div class="tasks">
      <draggable v-model="tasks"
                 class="dragArea"
                 :options="{ghostClass: 'ghost', group: {name: 'tasks', pull: 'clone', put: false}, draggable: '.draggable'}"
      >
        <div class="task draggable" :class="{'done': task.done}" v-for="task in tasks" :task_id="task.id" :from_task_pool="true" @click="showTask(task)">
          <div>
            <span class="color-jet name">
              {{ task.name }}
            </span>
            <span v-if="project && project.is_billed" class="ml-1">$</span>
          </div>
          <div class="subheading">{{ task.planed_hours_formatted }} / {{ task.assigned_hours_formatted }} / {{ task.completed_hours_formatted }}</div>
        </div>
      </draggable>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import ProgressBar from '../../../components/progress-bar'

export default {
  components: {
    draggable,
    ProgressBar,
  },
  created() {
    this.$root.$on('ProjectView::show', project => {
      this.project = project
      this.loadTasks()
      this.move('')
      this.$tpNav.scrollTop()
    })

    this.$root.$on('ProjectView::setProject', project => {
      this.project = project
      this.loadTasks()
    })

    this.$root.$on('ProjectView::move', to => {
      this.move(to)
    })

    this.$root.$on('Tasks::created', ({task}) => {
      this.loadTasks()
    })

    this.$root.$on('Tasks::updated', ({task}) => {
      this.loadTasks()
    })

    this.$root.$on('Tasks::deleted', ({task}) => {
      this.loadTasks()
    })

    this.$root.$on('ProjectView::reload', () => this.loadTasks())

    this.$root.$on('Projects::updated', ({project}) => {
      this.project.name = project.name
      this.project.deadline = project.deadline
      this.project.fixed_price = project.fixed_price
      this.project.completion_percentage = project.completion_percentage
      this.project.is_billed = project.is_billed
    })
  },
  data() {
    return {
      project: null,
      view_position: 'right-100',
      tasks: null,
    }
  },
  computed: {
    _project_deadline() {
      return this.project && this.project.deadline ? moment(this.project.deadline).format('YYYY-MM-DD') : 'No deadline'
    }
  },
  methods: {
    move(to) {
      this.view_position = to
    },
    backToClients() {
      this.$root.$emit('ClientProjects::show', false)
      this.move('right-100')
    },
    loadTasks() {
      if (this.project) {
        this.axios.get('/n/tasks', {params: {project_id: this.project.id, for_task_pool: true}}).then(response => {
          this.tasks = response.data.data
          this.calculateCompletionPercentage()
        })
      }
    },
    edit() {
      if (!this.$root.canEditBilledProjects(this.project.is_billed, true)) return;

      this.$root.$emit('ProjectModal::edit-project', {project_id: this.project.id})
    },
    createTask() {
      if (!this.$root.canEditBilledProjects(this.project.is_billed, true)) return;

      this.$root.$emit('TaskModal::create-task', {project: this.project})
    },
    showTask(task) {
      this.$root.$emit('TaskModal::show-task', {parent_id: task.id})
    },
    showProject() {
      this.$root.$emit('ProjectModal::show-project', {project_id: this.project.id})
    },
    calculateCompletionPercentage() {
      let done = _.filter(this.tasks, t => t.is_completed).length
      let total = this.tasks.length;

      if (total == 0) {
        this.project.completion_percentage = 0;
        return
      }

      this.project.completion_percentage = (100 * done) / total;
    }
  }
}
</script>
<style lang="scss">
  .project-view {
    .task.done {
      .name {
        text-decoration: line-through;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-pool/project-view.vue